<div class="container">
  <app-dashboard-header></app-dashboard-header>
  <div class="row">
    <app-dashboard-menu></app-dashboard-menu>
    <div class="graphics-area">
      <div class="top">
        <h4>Geral</h4>
        <div class="calendar"></div>
      </div>
      <div class="content">
        <div class="col col-2">
          <div class="card card-dashboard-graphic">
            <div class="title">Volume de atendimento de leads</div>
            <div class="subtitle">Número de leads que foram distribuídos, atendidos e represados.</div>
            <div class="content">
              <canvas baseChart height="280" [labels]="barChartLabels" [datasets]="barChartDatasets"
                [options]="barChartOptions" [chartType]="barChartType">
              </canvas>
            </div>
          </div>
        </div>
        <div class="col col-2">
          <div class="card card-dashboard-graphic">
            <div class="title">Capacidade leads x corretores</div>
            <div class="subtitle">Capacidade de atendimento relativo ao número de corretores.</div>
            <div class="content">
              <canvas id="greenChart" baseChart height="250" [datasets]="doughnutChartData" [labels]="doughnutChartLabels"
                [options]="doughnutChartOptions" [chartType]="doughnutChartType" [plugins]="doughnutChartPlugins">
              </canvas>
              <span>Regra de <strong>3</strong> leads simultâneos, total de <strong>50</strong> corretores para
                <strong>240</strong> leads distribuídos.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>